import React from 'react';
import {
  FaFacebookSquare,
  FaLinkedin,
  FaPhoneAlt,
  FaMobile,
} from 'react-icons/fa';
import { BsFillEnvelopeFill, BsGeoAlt } from 'react-icons/bs';
import { RiLoginBoxFill } from 'react-icons/ri';
import PropTypes from 'prop-types';
import '../style/style.css';
import { useTranslation } from 'react-i18next';
import juni from '../junifeup.png';
import reclamacoes from '../reclamacoes.png';

export default function Contacts({
  email,
  mobile,
  telephone,
  address,
  postalcode,
  linkedin,
  facebook,
  linkMaps,
  isAdmin,
}) {
  const { t } = useTranslation();

  return (
    <div className="footer" id="contactos">
      <div className="row">
        <div className="col col-md-6 col-12">
          <div className="footer-social">
            <div className="col">
              <a className="footer-social-link" href={facebook}>
                <FaFacebookSquare className="footer-icon" />
                {t('followUs')}
                Facebook
              </a>
            </div>
            <div className="col">
              <a
                className="footer-social-link footer-social-linkedln"
                href={linkedin}
              >
                <FaLinkedin className="footer-icon" />
                {t('followUs')}
                Linkedin
              </a>
            </div>
          </div>
          <div className="footer-info">
            <div className="footer-info-item">
              <BsFillEnvelopeFill className="footer-icon" />
              {email}
            </div>
            <div className="footer-info-item contacts-phone">
              <div className="col" id="footer-mobile">
                <div>
                  <FaMobile className="footer-icon" />
                  {mobile}
                </div>
              </div>
              <div className="col">
                <div>
            <div className="footer-info-item contacts-address">
              <div className="col">
                <BsGeoAlt className="footer-icon" />
                {address}
              </div>
              <div className="col">
                <BsGeoAlt
                  style={{ color: 'rgb(3, 130, 129, 0.01)' }}
                  className="footer-icon"
                />
                {postalcode}
              </div>
            </div>
          </div>
          <div className="footer-link">
            <a
              className="footer-info-item-title footer-link-item footer-info-item "
              href={isAdmin ? './backoffice' : './login'}
            >
              <RiLoginBoxFill className="footer-icon" />
              Login Administração
            </a>
          </div>
          <div className="footer-link">
            <a
              className="footer-info-item-title footer-link-item footer-info-item"
              href="https://www.livroreclamacoes.pt"
              target="_blank"
              rel="noreferrer"
            >
              <img
                style={{ marginLeft: '1em' }}
                alt="livro-reclamaçoes"
                src={reclamacoes}
                height="70"
                width="170"
              />
            </a>
          </div>
        </div>
        <div className="col col-md-6 col-12">
          <iframe
            title="Morada"
            src={linkMaps}
            style={{
              border: '0',
              width: '80%',
              height: '99%',
            }}
            allowFullScreen=""
            loading="lazy"
          />
        </div>
      </div>
      <div className="footer-powered">
        powered by
        <img src={juni} height="32" width="142" alt="junifeup" />
      </div>
    </div>
  );
}

Contacts.propTypes = {
  email: PropTypes.string.isRequired,
  mobile: PropTypes.string.isRequired,
  telephone: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  postalcode: PropTypes.string.isRequired,
  linkMaps: PropTypes.string.isRequired,
  facebook: PropTypes.string.isRequired,
  linkedin: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool.isRequired,
};
